/**
 * The shell's words for «Assigned to me» (`activities/assigned`, the shell's MyWork,
 * docs/design/assigned-to-me.md): the page, its groups by due day, a feed that does not answer,
 * «n more» and the home figure. A feed's own name and status words are its unit's. Kept beside the
 * catalogue and spread into it, so a parallel change to the catalogue does not collide with these.
 */
export const ASSIGNMENTS_EN = {
    'nav.activities.assigned': 'Assigned to me',
    'screen.activities.assigned.title': 'Assigned to me',
    'work.mine.title': 'Assigned to me',
    'work.mine.lede': 'Your open work from every unit, read live with your own access.',
    'work.mine.none': 'No unit offers you a list of assigned work yet.',
    'work.mine.empty': 'Nothing is assigned to you.',
    'work.mine.show': 'Show',
    'work.mine.reading': 'Reading your work…',
    'work.mine.unavailable': '{feed} is not available right now; the rest are shown.',
    'work.mine.more': '{n} more in {feed}',
    'work.mine.figures': 'Your work by due day',
    'work.mine.group.overdue': 'Overdue',
    'work.mine.group.today': 'Today',
    'work.mine.group.this_week': 'Later this week',
    'work.mine.group.later': 'Later',
    'work.mine.group.undated': 'No due day',
    'work.mine.at_least': 'At least this many: a unit holds more than it sent.',
    'home.figure.assigned': 'Assigned to me',
};
export const ASSIGNMENTS_AR = {
    'nav.activities.assigned': 'المسند إليّ',
    'screen.activities.assigned.title': 'المسند إليّ',
    'work.mine.title': 'المسند إليّ',
    'work.mine.lede': 'عملك المفتوح من كل الوحدات، يُقرأ مباشرة بصلاحياتك أنت.',
    'work.mine.none': 'لا تعرض عليك أي وحدة بعدُ قائمة بما أُسند إليك.',
    'work.mine.empty': 'لا شيء مسند إليك.',
    'work.mine.show': 'اعرض',
    'work.mine.reading': 'جارٍ قراءة عملك…',
    'work.mine.unavailable': '{feed} غير متاحة الآن؛ يُعرض الباقي.',
    'work.mine.more': '{n} أخرى في {feed}',
    'work.mine.figures': 'عملك حسب موعده',
    'work.mine.group.overdue': 'متأخر',
    'work.mine.group.today': 'اليوم',
    'work.mine.group.this_week': 'لاحقًا هذا الأسبوع',
    'work.mine.group.later': 'لاحقًا',
    'work.mine.group.undated': 'بلا موعد',
    'work.mine.at_least': 'هذا أقل عدد: لدى إحدى الوحدات أكثر مما أرسلت.',
    'home.figure.assigned': 'المسند إليّ',
};
//# sourceMappingURL=i18n-assignments.js.map